class e {
  constructor() {
    this.init = () => Promise.resolve(), this.setClientId = (r) => {
      console.info("Setting client ID:", r);
    }, this.captureError = (r, t) => {
      console.error(r, t);
    };
  }
}
export {
  e as DummyMonitoring
};
//# sourceMappingURL=DummyMonitoring.mjs.map
